import { render, staticRenderFns } from "./Step.vue?vue&type=template&id=fcff05f0&scoped=true"
import script from "./Step.vue?vue&type=script&lang=ts"
export * from "./Step.vue?vue&type=script&lang=ts"
import style0 from "./Step.vue?vue&type=style&index=0&id=fcff05f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcff05f0",
  null
  
)

export default component.exports